import "./footer.css";
import { useTranslation } from "../../shared/LanguageContext";


const Footer = () => {
    const { t } = useTranslation();
    return (
    <footer id="contacts">
        <div className="container" >
            <div className="top-footer">
                <div className="row">
                    <div className="col-xl-4 col-lg-4">
                        <p>{t("footer_desc")}</p>
                        <p className="footer-socials">
                            <a href="#" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://t.me/oqsaroyhospital" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-telegram"></i>
                            </a>
                            <a href="https://www.instagram.com/oqsaroyhospital" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram"></i>
                            </a>
                        </p>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                        <h4>{t("footer_contacts")}</h4>
                        <div className="footer-contact">
                            <div className="contact-info">
                                <div className="icon-wrapper">
                                    <i className="bi bi-geo-alt"></i>
                                </div>
                                <p>{t("footer_address_1")} <br></br>{t("footer_address_2")}</p>
                            </div>
                            <div className="contact-info">
                                <div className="icon-wrapper">
                                    <i className="bi bi-telephone"></i>
                                </div>
                                <p>
                                    <a href="tel:998554040003">+998 55 404 00 03</a><br />
                                </p>
                            </div>
                            <div className="contact-info">
                                <div className="icon-wrapper">
                                    <i className="bi bi-telephone"></i>
                                </div>
                                <p>
                                    <a href="tel:998554040003">+998 55 405 00 03</a><br />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-footer">
                <p className="text-center">
                    © Copyrights 2024 <a href="https://frakhmann.github.io/feedback/" target="_blank" rel="noopener noreferrer">Frakhmann</a>. {t("footer_rights")}
                </p>
            </div>
        </div>
    </footer>
    );
};

export default Footer;
